export default {
	FileManager: 'Explorateur de média',
	Upload: 'Charger',
	GlobalMedia: 'un média global',
	NoGlobalMedia: 'Pas de média global. Ajoutez-en un',
	LocalMedia: 'un média local',
	NoLocalMedia: 'Pas de média local. Ajoutez-en un',
	ApplicationMedia: 'un média d\'une application',
	NoApplicationMedia: 'Pas de média pour cette application.',
	ChooseMedia: 'Choisir ce média',
	Preview: 'Aperçu',
	Download: 'Télécharger',
	Remove: 'Supprimer',
	RemoveFile: 'Supprimer {fileName}',
	GoBack: 'Retour au(x) média(s)',
	RemoveFileDescription: 'Etes-vous sur de vouloir supprimer {fileName} ?',
	Close: 'Fermer',
	ConfirmText: 'Confirmer',
};
